import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface InfoCardProps {
  label: string;
  value: string;
  customValue?: React.ReactNode;
}

export function InfoCard({ label, value, customValue }: InfoCardProps) {
  const theme = useTheme();
  
  return (
    <Box sx={{ 
      background: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#FAFBFC', 
      borderRadius: 2, 
      p: 2, 
      border: `1px solid ${theme.palette.divider}` 
    }}>
      <Typography variant="body2" color={theme.palette.text.secondary} mb={0.5} fontWeight={500}>
        {label}
      </Typography>
      {customValue || (
        <Typography variant="body1" fontWeight={600} color={theme.palette.text.primary}>
          {value}
        </Typography>
      )}
    </Box>
  );
}